import { doc, DocumentReference } from 'firebase/firestore';
import { docData } from 'rxfire/firestore';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { IUser } from '../../../types';
import { authenticatedUserProvider } from '../../userProvider';
import { IDateRange } from '../dates/dateRangeProvider';

export interface IWeightUnitOption {
  label: 'Pounds' | 'Kilos';
  value: 'kgs' | 'lbs';
}

export interface IChangeCutoff {
  upperCutoff: number;
  lowerCutoff: number;
}

export const weightUnitOptions: IWeightUnitOption[] = [
  { label: 'Pounds', value: 'lbs' },
  { label: 'Kilos', value: 'kgs' },
];

export interface IWeightReportSettings {
  units: IWeightUnitOption;
  timeframe: IDateRange;
  baselineTimeframe: IDateRange;
  changeCutoffs: IChangeCutoff;
}

const defaultSettings: IWeightReportSettings = {
  units: { label: 'Kilos', value: 'kgs' },
  timeframe: {
    dateType: { label: 'Last Session', value: 'last-session' },
    dateRange: null,
  },
  baselineTimeframe: {
    dateType: { label: 'Previous Session', value: 'previous-session' },
    dateRange: null,
  },
  changeCutoffs: {
    upperCutoff: 5,
    lowerCutoff: 1.9,
  },
};

/**
 * @description observes weight report settings
 */

export const weightReportSettingsProvider =
  (): Observable<IWeightReportSettings> => {
    return authenticatedUserProvider().pipe(
      switchMap((user: IUser): Observable<IWeightReportSettings> => {
        return docData<IWeightReportSettings>(
          doc(
            user.services.firestore,
            `userProfiles/${user.id}/settings/weightReport`
          ) as DocumentReference<IWeightReportSettings>
        ).pipe(
          map((settings: IWeightReportSettings): IWeightReportSettings => {
            return { ...defaultSettings, ...settings };
          })
        );
      })
    );
  };
